import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    tableHeaderRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    tableDataRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    actionCell: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center",
        flex: 1.2
    },
    emptyStateContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 240
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 280
    },
    targetBadge: {
        alignSelf: "flex-start"
    },
    statBarTrack: {
        overflow: "hidden",
        width: 80
    },
    deleteDialogContent: {
        width: "100%"
    },
    paginationContainer: {
        width: "100%"
    },
    tableContainer: {
        overflow: "hidden"
    },
    searchContainer: {
        minWidth: 260,
        flex: 1
    },
    statBarFill: {
        height: "100%"
    },
    container: {
        width: "100%",
        flex: 1
    },
    targetCell: {
        flex: 1.8
    },
    statsCell: {
        flex: 1.8
    },
    dateCell: {
        flex: 1.6
    },
    titleCell: {
        flex: 3
    }
});
export default stylesheet;
